<div class="set-category-wrapper">
  <div class="header">
    <div class="left">
      <h3 class="title">{{'categories.CategorySetDialog.Title' | translate}}</h3>
      <p class="items-count">
        {{
        data.itemsCount > 1 ? ('categories.CategorySetDialog.ItemsCount' | translate: data.itemsCount) :
          ('categories.CategorySetDialog.OneItem' | translate: data.itemsCount)
        }}
      </p>
    </div>

    <mat-icon class="close" mat-dialog-close="true">close</mat-icon>
  </div>

  <div class="category-name">
    <mat-form-field class="example-full-width" appearance="standard">
      <mat-label>{{'system.Category' | translate}}</mat-label>
      <input type="text" matInput [formControl]="categoryName" />
    </mat-form-field>
  </div>

  <div class="categories" *ngIf="categories; else noCategories">

    <div
      *ngIf="isCreateNewCategory"
      (click)="createNewCategory()"
      class="create-new-category">
      <mat-icon class="icon">add</mat-icon>
      <p class="text">{{'categories.CategorySetDialog.CreateItem' | translate: categoryName.value}}</p>
    </div>

    <p class="category"
       *ngFor="let category of filteredCategories"
       (click)="setCategory(category)"
    >
      {{ category.Name }}
    </p>
  </div>

  <ng-template #noCategories>
    <div class="no-categories">
      <h3>{{'categories.CategorySetDialog.NoItems' | translate}}</h3>
    </div>
  </ng-template>

</div>
